<script lang="ts">
	import ContentBlocks from "@components/ContentBlocks.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import GalleryBlock from "@components/content-blocks/GalleryBlock.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { findImageInContentBlocks } from "@core/schema/utils/findImageInContentBlocks.js";
	import type { ArticleDetailProps } from "./ArticleDetailProps.js";

	const { article }: ArticleDetailProps = $props();
</script>

<Layout ogImage={article.primaryImage ?? article.images[0] ?? findImageInContentBlocks(article.content)}>
	<section class="pb-8 md:pb-16 lg:pb-20 full-width grid-container flex flex-col 2k:max-w-[116rem] 2k:mx-auto">
		<div class="flex flex-col gap-4 mb-10 max-w-[calc(72rem+var(--container-gap)] mx-auto">
			<div class="flex flex-col gap-4 max-w-screen-md mx-auto">
				<HugeHeading level={1} text={article.title} class="lg:!text-9xl !mb-0 mild" />
				{#if article.perex}
					<p class="text-[1.25rem]/[1.5] md:text-xl/[1.5] font-semibold max-w-screen-md">
						<Formatted text={article.perex} />
					</p>
				{/if}
				{#if article.primaryImage}
					<div class="bg-white rounded-lg p-4 mt-12">
						<Media
							class="rounded-lg"
							preload={{ fetchpriority: "high" }}
							source={article.primaryImage}
							alt="Úvodní fotka"
							width={736}
							height={414}
							sourcesets={{
								"<2xl": [414, 0],
								">2xl": [414, 0],
							}}
						/>
					</div>
				{/if}
			</div>
		</div>
		<ContentBlocks blocks={article.content} lightboxIdPerBlock align="center" />
		{#if article.images.length > 0}
			<div class="mt-16">
				<GalleryBlock data={{ images: article.images }} lightboxId={undefined} align="center" />
			</div>
		{/if}
	</section>
</Layout>
